import {
  canViewerPermission,
  getViewerEmailFromStorage,
  getViewerRoleType,
} from "./userMatrixStorage";
import { isPluginEnabled, PLUGIN_IDS } from "./registry";
import { isExecutiveRoleType } from "./shopAccess";

export function messagesPluginEnabled() {
  return isPluginEnabled(PLUGIN_IDS.PROJECT_COMMENTS);
}

/** Messages inbox page / nav — default on; Executive role defaults off via User Matrix. */
export function canAccessMessages(viewerEmail) {
  if (!messagesPluginEnabled()) return false;
  const email = viewerEmail ?? getViewerEmailFromStorage();
  const role = getViewerRoleType(email);
  if (isExecutiveRoleType(role)) {
    // Explicit matrix flag wins; missing key stays denied for Executive.
    return canViewerPermission(email, "canAccessMessages", false);
  }
  return canViewerPermission(email, "canAccessMessages", true);
}
